import { z } from 'zod';
import { displayNameSchema, emailSchema, PASSWORD_MAX_LENGTH } from './auth.js';
import { assignableRoleSchema } from './roles.js';
export const INVITATION_TTL_DAYS = 7;
/** Invite an existing managed member (memberId) or a new person (displayName + role). */
export const createInvitationRequestSchema = z.union([
    z.object({ email: emailSchema, memberId: z.string().uuid() }),
    z.object({ email: emailSchema, displayName: displayNameSchema, role: assignableRoleSchema }),
]);
export const invitationSchema = z.object({
    id: z.string().uuid(),
    memberId: z.string().uuid(),
    memberDisplayName: z.string(),
    email: z.string(),
    expiresAt: z.string(),
    createdAt: z.string(),
});
export const createInvitationResponseSchema = invitationSchema.extend({
    /** Shown once to the inviter so they can share it (e.g. on WhatsApp). */
    inviteUrl: z.string().url(),
});
export const invitationListResponseSchema = z.object({ items: z.array(invitationSchema) });
export const invitationPreviewSchema = z.object({
    familyName: z.string(),
    memberDisplayName: z.string(),
    inviterDisplayName: z.string().nullable(),
    email: z.string(),
    /** True when this email already has a login: accepting needs that login's password. */
    existingAccount: z.boolean(),
});
export const acceptInvitationRequestSchema = z.object({
    token: z.string().min(20).max(200),
    // A new account must meet the password policy; an existing one only has to match.
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
//# sourceMappingURL=invitations.js.map